import * as PIXI from 'pixi.js';
import { CARD_WIDTH, CARD_HEIGHT, getProxiedCardImageUrl } from '../utils/commonUtils';

export default class ThreeDimensionalCardContainer extends PIXI.Container {
    constructor(cardInstance) {
        super();

        const frontFaceTexture = PIXI.Assets.get(getProxiedCardImageUrl(cardInstance.imgUrl))
        this.frontFacePerspectiveMesh = new PIXI.PerspectiveMesh({
            texture: frontFaceTexture,
            pivot: {
                x: CARD_WIDTH / 2,
                y: CARD_HEIGHT / 2,
            },
        });
        this.frontFacePerspectiveMesh.setCorners(
            0, 0,
            CARD_WIDTH, 0,
            CARD_WIDTH, CARD_HEIGHT,
            0, CARD_HEIGHT,
        );
        this.addChild(this.frontFacePerspectiveMesh);

        const isLeader = cardInstance.type === 'Leader';
        let backFaceTexture = isLeader ? PIXI.Assets.get('3dLeaderCardBack') : PIXI.Assets.get('3dMainCardBack');
        this.backFacePerspectiveMesh = new PIXI.PerspectiveMesh({
            texture: backFaceTexture,
            pivot: {
                x: CARD_WIDTH / 2,
                y: CARD_HEIGHT / 2,
            },
        });
        this.backFacePerspectiveMesh.setCorners(
            CARD_WIDTH, 0,
            0, 0,
            0, CARD_HEIGHT,
            CARD_WIDTH, CARD_HEIGHT,
        );
        this.backFacePerspectiveMesh.visible = false;
        this.addChild(this.backFacePerspectiveMesh);
    }

    rotate(angleX, angleY, perspective = 300) {
        this.rotationX = angleX;
        this.rotationY = angleY;

        if (Math.abs(angleY) % 360 > 90 && Math.abs(angleY) % 360 < 270) {
            this.backFacePerspectiveMesh.visible = true;
        } else {
            this.backFacePerspectiveMesh.visible = false;
        }
        
        let points = [
            { x: 0, y: 0 },
            { x: CARD_WIDTH, y: 0 },
            { x: CARD_WIDTH, y: CARD_HEIGHT },
            { x: 0, y: CARD_HEIGHT },
        ];
        
        let outPoints = points.map((p) => ({ ...p }));

        let radX = (angleX * Math.PI) / 180;
        let radY = (angleY * Math.PI) / 180;
        let cosX = Math.cos(radX);
        let sinX = Math.sin(radX);
        let cosY = Math.cos(radY);
        let sinY = Math.sin(radY);

        for (let i = 0; i < points.length; i++) {
            const src = points[i];
            const out = outPoints[i];
            const x = src.x - CARD_WIDTH / 2;
            const y = src.y - CARD_HEIGHT / 2;
            let z = 0; // Assume initial z is 0 for this 2D plane

            // Rotate around Y axis
            const xY = cosY * x - sinY * z;

            z = sinY * x + cosY * z;

            // Rotate around X axis
            const yX = cosX * y - sinX * z;

            z = sinX * y + cosX * z;

            // Apply perspective projection
            const scale = perspective / (perspective - z);

            out.x = xY * scale + CARD_WIDTH / 2;
            out.y = yX * scale + CARD_HEIGHT / 2;
        }

        this.frontFacePerspectiveMesh.setCorners(
            outPoints[0].x, outPoints[0].y,
            outPoints[1].x, outPoints[1].y,
            outPoints[2].x, outPoints[2].y,
            outPoints[3].x, outPoints[3].y,
        );

        outPoints = points.map((p) => ({ ...p }));

        radX = (angleX * Math.PI) / 180;
        radY = ((angleY + 180) * Math.PI) / 180;
        cosX = Math.cos(radX);
        sinX = Math.sin(radX);
        cosY = Math.cos(radY);
        sinY = Math.sin(radY);

        for (let i = 0; i < points.length; i++) {
            const src = points[i];
            const out = outPoints[i];
            const x = src.x - CARD_WIDTH / 2;
            const y = src.y - CARD_HEIGHT / 2;
            let z = 0; // Assume initial z is 0 for this 2D plane

            // Rotate around Y axis
            const xY = cosY * x - sinY * z;

            z = sinY * x + cosY * z;

            // Rotate around X axis
            const yX = cosX * y - sinX * z;

            z = sinX * y + cosX * z;

            // Apply perspective projection
            const scale = perspective / (perspective - z);

            out.x = xY * scale + CARD_WIDTH / 2;
            out.y = yX * scale + CARD_HEIGHT / 2;
        }

        this.backFacePerspectiveMesh.setCorners(
            outPoints[0].x, outPoints[0].y,
            outPoints[1].x, outPoints[1].y,
            outPoints[2].x, outPoints[2].y,
            outPoints[3].x, outPoints[3].y,
        );
    }

    changeCard(cardInstance) {
        const frontFaceTexture = PIXI.Assets.get(getProxiedCardImageUrl(cardInstance?.imgUrl));
        this.frontFacePerspectiveMesh.texture = frontFaceTexture;
    }

    static async loadAssets() {
        await PIXI.Assets.load([
            { src: '/assets/vs_screen/leader_backface.png', alias: '3dLeaderCardBack' },
            { src: '/assets/main_deck_card_back.png', alias: '3dMainCardBack' },
        ]);
    }
}